import {
   FavoriteMedicineReplaceExpiredCommand,
   PatientContinuouslyUsedMedicineExtendedQuery,
   PatientContinuouslyUsedMedicineReplaceExpiredCommand,
   PatientMedicineQuery,
} from '@dreryk/egabinet-prescription-frontend-api';
import { Patient } from '@dreryk/egabinet-patient-frontend-api';
import { PatientId } from '@dreryk/egabinet-patient-published-language-api';
import { VisitContinuouslyUsedMedicineQuery } from '@dreryk/egabinet-visit-frontend-api';

import { refetchCqrsQuery, useCqrsCommand } from '@dreryk/command-query-react-common';
import { ActionEventInterceptor } from '@dreryk/react-components';
import { assertUnreachable } from '@dreryk/react-common';
import { Choice } from '@dreryk/watermelon';

import { MedicineReplacementSource } from '../medicineReplacement.types';
import { MedicineReplacementFormBean, MedicineReplacementFormController } from '../form/MedicineReplacementForm.types';

type MedicineReplaceExpiredActionInterceptorProps = Pick<MedicineReplacementFormController, 'handleSubmit'> & {
   readonly children: JSX.Element;
   readonly source: MedicineReplacementSource;
   readonly patientId?: Patient['id'];
};

export const MedicineReplaceExpiredActionInterceptor = (
   props: MedicineReplaceExpiredActionInterceptorProps
): JSX.Element => {
   const { executeAsync: removeWithdrawnMedicine } = useCqrsCommand<void, MedicineReplacementFormBean>(
      (parameters) => {
         switch (props.source) {
            case 'favorite': {
               const command = new FavoriteMedicineReplaceExpiredCommand();
               command.oldMedicineId = parameters.withdrawnMedicine.id;
               command.newMedicineId = parameters.newMedicine!.medicine.id;
               return command;
            }
            case 'continuouslyUsedMedicine': {
               const command = new PatientContinuouslyUsedMedicineReplaceExpiredCommand();
               command.oldMedicineId = parameters.withdrawnMedicine.id;
               command.newMedicineId = parameters.newMedicine!.medicine.id;
               command.patientId = Choice.withUseDefaultIfNull(props.patientId ? PatientId.of(props.patientId) : null);
               return command;
            }
            default:
               return assertUnreachable(props.source);
         }
      },
      {
         onSuccess: () => {
            refetchCqrsQuery(PatientMedicineQuery);
            refetchCqrsQuery(PatientContinuouslyUsedMedicineExtendedQuery);
            refetchCqrsQuery(VisitContinuouslyUsedMedicineQuery);
         },
      }
   );

   return (
      <ActionEventInterceptor action={props.handleSubmit(removeWithdrawnMedicine)}>
         {props.children}
      </ActionEventInterceptor>
   );
};
